<template>
  <div>
    <div>
      <user-view-info
        @refresh-data="refreshUserInfoData"
      />
    </div>

    <b-tabs
      v-model="tabIndex"
      pills
      lazy
    >

      <!-- tab: 基本資料 -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">基本資料</span>
        </template>

        <!-- <user-general
          @refresh-data="refreshUserInfoData"
        /> -->
      </b-tab>

      <!-- tab: 工作階段 -->
      <b-tab>
        <template #title>
          <feather-icon
            icon="AirplayIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">工作階段</span>
        </template>

        <!-- <user-workphase /> -->
      </b-tab>

    </b-tabs>
  </div>
</template>

<script>
// API
import { onUnmounted } from '@vue/composition-api'
// UI
import { BTabs, BTab } from 'bootstrap-vue'

import store from '@/store'
// import UserGeneral from './components/general/General.vue'
// import UserPassword from './components/password1/Password.vue'
// import UserWorkphase from './components/workphase/Workphase.vue'
import UserViewInfo from './UserViewInfo.vue'
import useStoreModule from '../useStoreModule'
import { useUserViewGeneral } from '../useUser'
import router from '@/router'

export default {
  metaInfo() {
    return {
      title: this.title ? this.title : store.state['app-config'].app.appName,
      titleTemplate: `%s - ${store.state.app.titleTemplate}`,
    }
  },
  components: {
    BTabs,
    BTab,

    // UserGeneral,
    // UserPassword,
    // UserWorkphase,
    // MemberNotify,
    // MemberWorkphase,
    // MemberPassword,
    UserViewInfo,
  },
  data() {
    return {
      tabIndex: 0,
      title: router.currentRoute.meta.pageTitle,
    }
  },
  setup() {
    // 註冊模組
    const USER_ADMIN_STORE_MODULE_NAME = 'admin-user'

    if (!store.hasModule(USER_ADMIN_STORE_MODULE_NAME)) store.registerModule(USER_ADMIN_STORE_MODULE_NAME, useStoreModule)

    onUnmounted(() => {
      if (store.hasModule(USER_ADMIN_STORE_MODULE_NAME)) store.unregisterModule(USER_ADMIN_STORE_MODULE_NAME)
    })

    const userID = router.currentRoute.params.id

    const {
      isInfoBusy,
      generalData,
      getUserInfoData,
    } = useUserViewGeneral()

    const refreshUserInfoData = () => getUserInfoData({ user_id: userID })

    refreshUserInfoData()

    return {
      userID,
      isInfoBusy,
      generalData,
      getUserInfoData,
      refreshUserInfoData,
    }
  },
}
</script>
